var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#0F5BF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.625C16 34.6057 28.1443 46.75 43.125 46.75C43.8009 46.75 44.471 46.7253 45.1345 46.6767C45.8959 46.6209 46.2766 46.5931 46.6232 46.3935C46.9102 46.2283 47.1824 45.9354 47.3263 45.637C47.5 45.2768 47.5 44.8567 47.5 44.0165V39.0862C47.5 38.3796 47.5 38.0263 47.3837 37.7235C47.281 37.4559 47.1141 37.2177 46.8978 37.0298C46.6529 36.817 46.3209 36.6962 45.6569 36.4548L40.0449 34.4141C39.2723 34.1331 38.886 33.9926 38.5195 34.0165C38.1964 34.0375 37.8854 34.1478 37.6211 34.3351C37.3215 34.5475 37.11 34.9 36.6871 35.6049L36.6871 35.6049L35.25 38C30.6127 35.8998 26.8533 32.1355 24.75 27.5L27.1451 26.0629C27.85 25.64 28.2025 25.4285 28.4149 25.1289C28.6022 24.8646 28.7125 24.5536 28.7335 24.2305C28.7574 23.864 28.6169 23.4777 28.3359 22.7051L26.2952 17.0931C26.0538 16.4291 25.933 16.0971 25.7202 15.8522C25.5323 15.6359 25.2941 15.469 25.0265 15.3663C24.7237 15.25 24.3704 15.25 23.6638 15.25H18.7335C17.8933 15.25 17.4732 15.25 17.113 15.4237C16.8146 15.5676 16.5217 15.8398 16.3565 16.1268C16.1569 16.4734 16.1291 16.8541 16.0733 17.6155C16.0247 18.279 16 18.9491 16 19.625Z",
    stroke: "white",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.2868eb8e14799d6c880d46f752e012c7.svg";
export { ForwardRef as ReactComponent };